module.exports = __webpack_public_path__ + "static/media/dmsans-medium-webfont.d2746f6c.woff";